// AUTO-GENERATED by scripts/sync-experiment-assignment-policy.mjs; do not edit.
// Source: business/ishvaram/data/governance/experiment_assignment_epochs.json

export const EXPERIMENT_ASSIGNMENT_POLICIES = {
  "phone_gate_2026_07": {
    "assignmentVersion": "fnv1a-fmix32-v1",
    "analysisStartDate": "2026-07-09",
    "acceptUnversionedFrom": "2026-07-09",
    "acceptUnversionedThrough": "2026-07-12",
    "invalidBeforeReason": "The original bare FNV assignment was measurably biased. Jul 2-7 exposure has SRM; Jul 9+ uses the uniform fmix32 assignment. Jul 8 is excluded as the mixed deployment day."
  },
  "resolution_package_v1": {
    "assignmentVersion": "fnv1a-fmix32-v1",
    "analysisStartDate": "2026-07-09",
    "acceptUnversionedFrom": "2026-07-09",
    "acceptUnversionedThrough": "2026-07-12",
    "invalidBeforeReason": "Rows before the fmix32 assignment epoch are retained as history but are not decision-valid."
  },
  "resolution_package_pilot_2026_07": {
    "assignmentVersion": "fnv1a-fmix32-v1",
    "analysisStartDate": "2026-07-10",
    "acceptUnversionedFrom": "2026-07-10",
    "acceptUnversionedThrough": "2026-07-12",
    "invalidBeforeReason": "The bounded pilot began after the fmix32 assignment epoch."
  },
  "chat_offer_timing_pilot_2026_07": {
    "assignmentVersion": "fnv1a-fmix32-v1",
    "analysisStartDate": "2026-07-12",
    "acceptUnversionedFrom": "2026-07-12",
    "acceptUnversionedThrough": "2026-07-12",
    "invalidBeforeReason": "The bounded timing pilot began on the fmix32 epoch; only its July 12 deployment window may contain compatible unversioned exposure."
  },
  "offer_proof_first_pilot_2026_07": {
    "assignmentVersion": "fnv1a-fmix32-v1",
    "analysisStartDate": "2026-07-13",
    "acceptUnversionedFrom": "2026-07-13",
    "acceptUnversionedThrough": "2026-07-13",
    "invalidBeforeReason": "The proof-first pilot began with versioned fmix32 assignment; July 13 is the deployment compatibility boundary."
  },
  "session_price_pilot_2026_07": {
    "assignmentVersion": "fnv1a-fmix32-durable-v2",
    "analysisStartDate": "2026-07-24",
    "acceptUnversionedFrom": "2026-07-24",
    "acceptUnversionedThrough": "2026-07-24",
    "invalidBeforeReason": "The July 16-23 price epoch lost the exposure receipt for 31 of 46 quick-family orders, including every captured quick-family purchase. July 24 restarts the unchanged fmix32 assignment with durable, idempotent exposure delivery and fail-closed order coverage."
  },
  "chat_concern_match_pilot_2026_07": {
    "assignmentVersion": "fnv1a-fmix32-v1",
    "analysisStartDate": "2026-07-16",
    "acceptUnversionedFrom": "2026-07-16",
    "acceptUnversionedThrough": "2026-07-16",
    "invalidBeforeReason": "The concern-match pilot began with versioned fmix32 assignment; July 16 is the deployment compatibility boundary."
  },
  "report_bundle_upgrade_pilot_2026_07": {
    "assignmentVersion": "fnv1a-fmix32-v1",
    "analysisStartDate": "2026-07-17",
    "acceptUnversionedFrom": "2026-07-17",
    "acceptUnversionedThrough": "2026-07-17",
    "invalidBeforeReason": "The bundle-upgrade pilot began with versioned fmix32 assignment; July 17 is the deployment compatibility boundary."
  },
  "daily_timing_v2_pilot_2026_07": {
    "assignmentVersion": "fnv1a-fmix32-v1",
    "analysisStartDate": "2026-07-19",
    "acceptUnversionedFrom": "2026-07-19",
    "acceptUnversionedThrough": "2026-07-19",
    "invalidBeforeReason": "The Daily Timing v2 current-versus-v2 pilot begins on the first full IST day after its governed runtime wiring; earlier unconditional preview renders are excluded."
  },
  "kundali_preview_pilot_2026_09": {
    "assignmentVersion": "fnv1a-fmix32-durable-v2",
    "analysisStartDate": "2026-09-17",
    "acceptUnversionedFrom": "2026-09-17",
    "acceptUnversionedThrough": "2026-09-17",
    "invalidBeforeReason": "New September preview pilot; earlier retired phone experiments are not pooled with this cohort."
  }
} as const;
